/**
 * Auth Module — public API
 *
 * Single entry point for auth throughout the app.
 * Consumer code should only import from this file.
 */

// Store (Zustand hook + initialization)
export { useAuthStore, initializeAuth, getAuthProvider, destroyAuth } from './store';

// Adapter factory
export { createSupabaseAdapter } from './adapters/supabase';

// Types & errors
export { AuthProviderError } from './types';
export type {
  AuthProvider,
  AuthUser,
  AuthSession,
  AuthResult,
  SignUpResult,
  AuthEventType,
  AuthErrorCode,
  AuthMachineState,
} from './types';
